<template>
  <v-app-bar
    :color="localColor"
    :style="styles['appBar']"
    :class="classes['appBar']"
    :hide-on-scroll="hideOnScroll"
    :inverted-scroll="invertedScroll"
    :flat="flat"
    :absolute="absolute"
    app
  >
    <slot name="nav-icon">
      <v-app-bar-nav-icon
        v-on:click="emit('nav-icon-click')"
      ></v-app-bar-nav-icon>
    </slot>
    <slot name="content">
      <v-toolbar-title>{{title}}</v-toolbar-title>
    </slot>
    <v-spacer></v-spacer>
    <slot name="end-buttons">
      <div v-if="variant == 'login'" class="d-flex">
        <UserMenu
          :user="user"
        >
          <template v-slot:activator="{on, bind}">
            <v-btn 
              icon
              class="mr-3"
              v-on="on"
              v-bind="bind"
            >
              <v-badge
                :color="badgesColor"
                :content="loginBadgeContent"
                :value="loginBadgeValue"
                :bottom="badgeIsBottom"
                :left="badgeIsLeft"
              >
                <v-icon>
                  mdi-account
                </v-icon>
              </v-badge>
            </v-btn>
          </template>
        </UserMenu>
      </div>
      <div v-else-if="variant == 'commercial'" class="d-flex">
        <v-btn 
          icon 
          class="mr-3"
        >
          <v-badge
            :color="badgesColor"
            :content="cartBadgeContent"
            :value="cartBadgeValue"
            :bottom="badgeIsBottom"
            :left="badgeIsLeft"
          >
            <v-icon>
              mdi-cart
            </v-icon>
          </v-badge>
        </v-btn>
        <UserMenu
          :user="user"
        >
          <template v-slot:activator="{on, bind}">
            <v-btn 
              icon
              class="mr-3"
              v-on="on"
              v-bind="bind"
            >
              <v-badge
                :color="badgesColor"
                :content="loginBadgeContent"
                :value="loginBadgeValue"
                :bottom="badgeIsBottom"
                :left="badgeIsLeft"
              >
                <v-icon>
                  mdi-account
                </v-icon>
              </v-badge>
            </v-btn>
          </template>
        </UserMenu>
      </div>
    </slot>
  </v-app-bar>
</template>

<script>
import emittable from '../../mixins/emittable.js'

import { UserMenu } from '../loggable'
import { 
  VAppBar, 
  VAppBarNavIcon, 
  VToolbarTitle, 
  VSpacer, 
  VBtn, 
  VBadge, 
  VIcon 
} from 'vuetify/lib'

export default {
  name: "AppBar",
  mixins: [emittable],
  components: {
    UserMenu,
    VAppBar, 
    VAppBarNavIcon, 
    VToolbarTitle, 
    VSpacer, 
    VBtn, 
    VBadge, 
    VIcon 
  },
  data: function() {
    return {
      loginBadgeValue: false,
      loginBadgeContent: undefined,
      cartBadgeValue: false,
      cartBadgeContent: undefined,
      localColor: this.color
    }
  },
  mounted: function() {
    this.assignBadgesVars(this.badges)

    if(this.colorizeOnScroll) {
      this.localColor = 'transparent'
      let handleOnScroll = function() {
        if(document.getElementById(this.scrollingElementId)) {
          if(document.getElementById(this.scrollingElementId).scrollTop == 0) {
            this.localColor = 'transparent'
          } else {
            this.localColor = this.color
          }
        } else {
          if(window.scrollY == 0) {
            this.localColor = 'transparent'
          } else {
            this.localColor = this.color
          }
        }
      }
      handleOnScroll = handleOnScroll.bind(this)
      if(document.getElementById(this.scrollingElementId)) {
        document.getElementById(this.scrollingElementId).onscroll = handleOnScroll
      } else {
        window.onscroll = handleOnScroll
      }
    }
  },
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    title: {
      type: String,
      default: undefined
    },
    flat: {
      type: Boolean,
      default: false
    },
    absolute: {
      type: Boolean,
      default: false
    },
    hideOnScroll: {
      type: Boolean,
      default: false
    },
    scrollingElementId: {
      type: String,
      default: undefined
    },
    colorizeOnScroll: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: function() {
        return {}
      }
    },
    invertedScroll: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'custom',
      validator: function(value) {
        return ['custom', 'login', 'commercial'].indexOf(value) != -1
      } 
    },
    badges: {
      type: Object,
      default: function() {
        return {}
      }
    },
    badgesColor: {
      type: String,
      default: 'secondary'
    },
    badgesPosition: {
      type: String,
      default: 'top-right',
      validator: function(value) {
        return ['top-left', 'top-right', 'bottom-left', 'bottom-right'].indexOf(value) != -1
      }
    },
    styles: {
      type: Object,
      default: function () {
        return {
          appBar: {},
        };
      },
    },
    classes: {
      type: Object,
      default: function () {
        return {
          appBar: {},
        };
      },
    },
  },
  methods: {
    assignBadgesVars(object) {
      if(typeof object === 'object' && object !== null) {
        this.loginBadgeValue = object.loginVisible ? true : false
        this.loginBadgeContent = object.loginContent
        this.cartBadgeValue = object.cartVisible ? true : false
        this.cartBadgeContent = object.cartContent
      }
    }
  },
  computed: {
    badgeIsBottom() {
      return ['bottom-left', 'bottom-right'].indexOf(this.badgesPosition) != -1
    },
    badgeIsLeft() {
      return ['bottom-left', 'top-left'].indexOf(this.badgesPosition) != -1
    },
  },
  watch: {
    badges: function(newVal) {
      this.assignBadgesVars(newVal)
    } 
  }
}
</script>

<style>

</style>